export const SMALL_WIDTH_BREAKPOINT = 1255;
